import React from 'react'
import { ReactComponent as Icon } from "../../../../../assets/svg/actions/icn-chevron-down.svg"

import '../../../../../assets/sass/pages/landing/pricing/components/see-more-button.scss'

export const SeeMoreButton = () => {
    const handleScroll = () => {
        document.querySelector('.clubs-section').scrollIntoView({ behavior: 'smooth' });
    }
    return (
        <div className="see-more-button" onClick={() => handleScroll()}>
            <p className="see-more-button--text">See More</p>
            <Icon className="see-more-button--icon" />
        </div>
    )
}
